import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "tinyOffset10": "letter-page-by-username-8d9bc255-tinyOffset10-WXUgJq",
  "wide1": "letter-page-by-username-8d9bc255-wide1-WXUgJq",
  "wide10": "letter-page-by-username-8d9bc255-wide10-WXUgJq",
  "default4": "letter-page-by-username-8d9bc255-default4-WXUgJq",
  "xwideOffset2": "letter-page-by-username-8d9bc255-xwideOffset2-WXUgJq",
  "confined8": "letter-page-by-username-8d9bc255-confined8-WXUgJq",
  "tiny9": "letter-page-by-username-8d9bc255-tiny9-WXUgJq",
  "confined11": "letter-page-by-username-8d9bc255-confined11-WXUgJq",
  "tinyOffset4": "letter-page-by-username-8d9bc255-tinyOffset4-WXUgJq",
  "confinedOffset1": "letter-page-by-username-8d9bc255-confinedOffset1-WXUgJq",
  "confinedOffset7": "letter-page-by-username-8d9bc255-confinedOffset7-WXUgJq",
  "wideOffset9": "letter-page-by-username-8d9bc255-wideOffset9-WXUgJq",
  "wide2": "letter-page-by-username-8d9bc255-wide2-WXUgJq",
  "defaultOffset1": "letter-page-by-username-8d9bc255-defaultOffset1-WXUgJq",
  "defaultOffset3": "letter-page-by-username-8d9bc255-defaultOffset3-WXUgJq",
  "tinyOffset6": "letter-page-by-username-8d9bc255-tinyOffset6-WXUgJq",
  "xwide10": "letter-page-by-username-8d9bc255-xwide10-WXUgJq",
  "confined12": "letter-page-by-username-8d9bc255-confined12-WXUgJq",
  "xwide11": "letter-page-by-username-8d9bc255-xwide11-WXUgJq",
  "xwideOffset3": "letter-page-by-username-8d9bc255-xwideOffset3-WXUgJq",
  "wideOffset0": "letter-page-by-username-8d9bc255-wideOffset0-WXUgJq",
  "tinyOffset11": "letter-page-by-username-8d9bc255-tinyOffset11-WXUgJq",
  "wide0": "letter-page-by-username-8d9bc255-wide0-WXUgJq",
  "grid": "letter-page-by-username-8d9bc255-grid-WXUgJq",
  "default12": "letter-page-by-username-8d9bc255-default12-WXUgJq",
  "default0": "letter-page-by-username-8d9bc255-default0-WXUgJq",
  "wideOffset10": "letter-page-by-username-8d9bc255-wideOffset10-WXUgJq",
  "confined9": "letter-page-by-username-8d9bc255-confined9-WXUgJq",
  "wideOffset11": "letter-page-by-username-8d9bc255-wideOffset11-WXUgJq",
  "tinyOffset0": "letter-page-by-username-8d9bc255-tinyOffset0-WXUgJq",
  "tiny2": "letter-page-by-username-8d9bc255-tiny2-WXUgJq",
  "wide4": "letter-page-by-username-8d9bc255-wide4-WXUgJq",
  "col": "letter-page-by-username-8d9bc255-col-WXUgJq",
  "xwide5": "letter-page-by-username-8d9bc255-xwide5-WXUgJq",
  "tinyOffset3": "letter-page-by-username-8d9bc255-tinyOffset3-WXUgJq",
  "wide5": "letter-page-by-username-8d9bc255-wide5-WXUgJq",
  "default10": "letter-page-by-username-8d9bc255-default10-WXUgJq",
  "wideOffset6": "letter-page-by-username-8d9bc255-wideOffset6-WXUgJq",
  "defaultOffset7": "letter-page-by-username-8d9bc255-defaultOffset7-WXUgJq",
  "default6": "letter-page-by-username-8d9bc255-default6-WXUgJq",
  "armstrongGridContainer": "letter-page-by-username-8d9bc255-armstrongGridContainer-WXUgJq",
  "confined6": "letter-page-by-username-8d9bc255-confined6-WXUgJq",
  "wide9": "letter-page-by-username-8d9bc255-wide9-WXUgJq",
  "xwideOffset9": "letter-page-by-username-8d9bc255-xwideOffset9-WXUgJq",
  "xwide12": "letter-page-by-username-8d9bc255-xwide12-WXUgJq",
  "xwideOffset11": "letter-page-by-username-8d9bc255-xwideOffset11-WXUgJq",
  "default3": "letter-page-by-username-8d9bc255-default3-WXUgJq",
  "wide6": "letter-page-by-username-8d9bc255-wide6-WXUgJq",
  "xwideOffset0": "letter-page-by-username-8d9bc255-xwideOffset0-WXUgJq",
  "xwideOffset4": "letter-page-by-username-8d9bc255-xwideOffset4-WXUgJq",
  "wideGridContainer": "letter-page-by-username-8d9bc255-wideGridContainer-WXUgJq",
  "defaultOffset4": "letter-page-by-username-8d9bc255-defaultOffset4-WXUgJq",
  "wide11": "letter-page-by-username-8d9bc255-wide11-WXUgJq",
  "xwide2": "letter-page-by-username-8d9bc255-xwide2-WXUgJq",
  "wideOffset8": "letter-page-by-username-8d9bc255-wideOffset8-WXUgJq",
  "tinyOffset9": "letter-page-by-username-8d9bc255-tinyOffset9-WXUgJq",
  "xwide3": "letter-page-by-username-8d9bc255-xwide3-WXUgJq",
  "tiny0": "letter-page-by-username-8d9bc255-tiny0-WXUgJq",
  "defaultOffset9": "letter-page-by-username-8d9bc255-defaultOffset9-WXUgJq",
  "confined0": "letter-page-by-username-8d9bc255-confined0-WXUgJq",
  "wide3": "letter-page-by-username-8d9bc255-wide3-WXUgJq",
  "xwide0": "letter-page-by-username-8d9bc255-xwide0-WXUgJq",
  "xwideOffset7": "letter-page-by-username-8d9bc255-xwideOffset7-WXUgJq",
  "confined10": "letter-page-by-username-8d9bc255-confined10-WXUgJq",
  "defaultOffset10": "letter-page-by-username-8d9bc255-defaultOffset10-WXUgJq",
  "tinyOffset2": "letter-page-by-username-8d9bc255-tinyOffset2-WXUgJq",
  "tiny11": "letter-page-by-username-8d9bc255-tiny11-WXUgJq",
  "confinedOffset8": "letter-page-by-username-8d9bc255-confinedOffset8-WXUgJq",
  "wideOffset3": "letter-page-by-username-8d9bc255-wideOffset3-WXUgJq",
  "confinedOffset5": "letter-page-by-username-8d9bc255-confinedOffset5-WXUgJq",
  "wide8": "letter-page-by-username-8d9bc255-wide8-WXUgJq",
  "xwideOffset8": "letter-page-by-username-8d9bc255-xwideOffset8-WXUgJq",
  "xwide6": "letter-page-by-username-8d9bc255-xwide6-WXUgJq",
  "confined5": "letter-page-by-username-8d9bc255-confined5-WXUgJq",
  "default2": "letter-page-by-username-8d9bc255-default2-WXUgJq",
  "tinyOffset7": "letter-page-by-username-8d9bc255-tinyOffset7-WXUgJq",
  "tiny5": "letter-page-by-username-8d9bc255-tiny5-WXUgJq",
  "tiny8": "letter-page-by-username-8d9bc255-tiny8-WXUgJq",
  "wide12": "letter-page-by-username-8d9bc255-wide12-WXUgJq",
  "confined1": "letter-page-by-username-8d9bc255-confined1-WXUgJq",
  "xwideOffset6": "letter-page-by-username-8d9bc255-xwideOffset6-WXUgJq",
  "defaultOffset6": "letter-page-by-username-8d9bc255-defaultOffset6-WXUgJq",
  "xwide4": "letter-page-by-username-8d9bc255-xwide4-WXUgJq",
  "row": "letter-page-by-username-8d9bc255-row-WXUgJq",
  "confinedOffset11": "letter-page-by-username-8d9bc255-confinedOffset11-WXUgJq",
  "xwideOffset10": "letter-page-by-username-8d9bc255-xwideOffset10-WXUgJq",
  "standardGridContainer": "letter-page-by-username-8d9bc255-standardGridContainer-WXUgJq",
  "defaultOffset11": "letter-page-by-username-8d9bc255-defaultOffset11-WXUgJq",
  "xwide8": "letter-page-by-username-8d9bc255-xwide8-WXUgJq",
  "wideOffset1": "letter-page-by-username-8d9bc255-wideOffset1-WXUgJq",
  "gridContainer": "letter-page-by-username-8d9bc255-gridContainer-WXUgJq",
  "confinedOffset4": "letter-page-by-username-8d9bc255-confinedOffset4-WXUgJq",
  "xwideOffset5": "letter-page-by-username-8d9bc255-xwideOffset5-WXUgJq",
  "tinyOffset1": "letter-page-by-username-8d9bc255-tinyOffset1-WXUgJq",
  "wideOffset5": "letter-page-by-username-8d9bc255-wideOffset5-WXUgJq",
  "wide7": "letter-page-by-username-8d9bc255-wide7-WXUgJq",
  "tiny12": "letter-page-by-username-8d9bc255-tiny12-WXUgJq",
  "tiny4": "letter-page-by-username-8d9bc255-tiny4-WXUgJq",
  "tiny7": "letter-page-by-username-8d9bc255-tiny7-WXUgJq",
  "wideOffset4": "letter-page-by-username-8d9bc255-wideOffset4-WXUgJq",
  "tiny3": "letter-page-by-username-8d9bc255-tiny3-WXUgJq",
  "confinedOffset6": "letter-page-by-username-8d9bc255-confinedOffset6-WXUgJq",
  "wideOffset7": "letter-page-by-username-8d9bc255-wideOffset7-WXUgJq",
  "confined2": "letter-page-by-username-8d9bc255-confined2-WXUgJq",
  "confinedOffset2": "letter-page-by-username-8d9bc255-confinedOffset2-WXUgJq",
  "tiny1": "letter-page-by-username-8d9bc255-tiny1-WXUgJq",
  "confined3": "letter-page-by-username-8d9bc255-confined3-WXUgJq",
  "tiny10": "letter-page-by-username-8d9bc255-tiny10-WXUgJq",
  "default7": "letter-page-by-username-8d9bc255-default7-WXUgJq",
  "default8": "letter-page-by-username-8d9bc255-default8-WXUgJq",
  "confinedOffset3": "letter-page-by-username-8d9bc255-confinedOffset3-WXUgJq",
  "xwideOffset1": "letter-page-by-username-8d9bc255-xwideOffset1-WXUgJq",
  "defaultOffset5": "letter-page-by-username-8d9bc255-defaultOffset5-WXUgJq",
  "default9": "letter-page-by-username-8d9bc255-default9-WXUgJq",
  "confined4": "letter-page-by-username-8d9bc255-confined4-WXUgJq",
  "tinyOffset8": "letter-page-by-username-8d9bc255-tinyOffset8-WXUgJq",
  "xwide7": "letter-page-by-username-8d9bc255-xwide7-WXUgJq",
  "default5": "letter-page-by-username-8d9bc255-default5-WXUgJq",
  "default11": "letter-page-by-username-8d9bc255-default11-WXUgJq",
  "tinyOffset5": "letter-page-by-username-8d9bc255-tinyOffset5-WXUgJq",
  "default1": "letter-page-by-username-8d9bc255-default1-WXUgJq",
  "tiny6": "letter-page-by-username-8d9bc255-tiny6-WXUgJq",
  "confinedOffset9": "letter-page-by-username-8d9bc255-confinedOffset9-WXUgJq",
  "wideOffset2": "letter-page-by-username-8d9bc255-wideOffset2-WXUgJq",
  "xwide9": "letter-page-by-username-8d9bc255-xwide9-WXUgJq",
  "xwide1": "letter-page-by-username-8d9bc255-xwide1-WXUgJq",
  "defaultOffset8": "letter-page-by-username-8d9bc255-defaultOffset8-WXUgJq",
  "defaultOffset2": "letter-page-by-username-8d9bc255-defaultOffset2-WXUgJq",
  "confinedOffset10": "letter-page-by-username-8d9bc255-confinedOffset10-WXUgJq",
  "confined7": "letter-page-by-username-8d9bc255-confined7-WXUgJq",
  "confinedOffset0": "letter-page-by-username-8d9bc255-confinedOffset0-WXUgJq"
};